var path = '/modules/users/views/pages/list.tpl.html';
var html = "<listview store=\"vm.store\" ng-if=\"vm.currentView === 'list'\"></listview>\n<div ng-if=\"vm.currentView === 'grid'\">\n    <div class=\"heading-toolset-wrapper\">\n        <h1>Users</h1>\n    </div>\n    <al-users-grid-view on-switch-to-list-view=\"vm.changeView('list')\"></al-users-grid-view>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/users/views/pages/list.tpl.html
// module id = 2174
// module chunks = 1